<!--components\Alineacion\EsImportante.vue-->
<template>
  <section class="flex flex-col pb-10 pt-10">
    <PanelTipo1 
      :titulo1="Data.titulo1" 
      :parrafos1="Data.parrafos1" 
      :imagen1="Data.imagen1"
      :imagenfondo="Data.imagenfondo"
      claseimagenFondo="object-cover"

      :objetoDerecho="Data.objetoDerecho" 
      orden-texto="md:order-2" 
      orden-imagen="md:order-1" 
      color-texto="text-black"
      espaciado="py-0 md:py-0"
      config-imagen="aspect-square object-contain w-[70%] md:w-[70%] transition-transform duration-500 ease-in-out hover:scale-110 cursor-pointer relative"
      config-padding="px-8 md:px-12 pt-16 md:pt-24 pb-12 md:pb-24" 
      contenedor-padre="w-full" 
      clasediv1="p-4 md:p-14 bg-white"
      contenedor-padre-sub="w-full" 
      contenedor-imagen="flex items-center justify-center p-4 md:p-4" />
  </section>
</template>

<script setup>
import { ref } from 'vue'
import PanelTipo1 from '~/components/Paneles/PanelTipo1.vue'

const Data = ref({
  titulo1: '¿Por qué es importante realizar la alineación?',
  parrafos1: [
    'Para corregirlo, se sube el auto a un elevador y, con los equipos de medición necesarios, se comprueban los niveles del vehículo. Con estos datos se pueden corregir los desajustes de la dirección. La alineación ajusta los ángulos de las ruedas, manteniéndolas perpendiculares al suelo y paralelas entre sí.'
  ],
  //imagenfondo: '/img/frenos/landings/BG-frenos.webp',  pendiente
  objetoDerecho: [
    {
      parrafos: ['Porque previene el desgaste irregular de los neumáticos, aumentando su vida útil.'],
      imagen: '/img/alineacion/ico1.png'
    },
    {
      parrafos: ['Disminuye la fricción del neumático en el suelo, contribuyendo con la economía de combustible.'],
      imagen: '/img/alineacion/ico2.png'
    },
    {
      parrafos: ['Mejora la facilidad de conducción y la seguridad.'],
      imagen: '/img/alineacion/ico3.png'
    }
  ]
})
</script>